var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _path, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _path2, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _line112, _line113, _line114, _line115, _line116, _line117, _line118, _line119, _line120, _line121, _line122, _line123, _line124, _line125, _line126, _line127, _line128, _line129, _line130, _line131, _line132, _line133, _line134, _line135, _line136, _line137, _line138, _line139, _line140, _line141, _line142, _line143, _line144, _line145, _line146, _line147, _line148, _line149, _line150, _line151, _line152, _line153, _line154, _line155, _line156, _line157, _line158, _line159, _line160, _line161, _line162, _line163, _line164, _line165, _line166, _line167, _path3, _line168, _line169, _line170, _line171, _line172, _line173, _path4, _line174, _line175, _line176, _line177, _line178, _line179, _line180, _line181, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _rect3, _rect4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect5, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogov2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 56,
    viewBox: "0 0 145 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 72.6914,
    y1: 2.19286,
    x2: 83.9277,
    y2: 2.19286,
    stroke: "#00B0F0",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 77.186,
    y1: 3.43205,
    x2: 88.4223,
    y2: 3.43205,
    stroke: "#5D1593",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 6.89951,
    x2: 83.9277,
    y2: 6.89951,
    stroke: "#92D050",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 81.6807,
    y1: 9.83443,
    x2: 86.9243,
    y2: 9.83443,
    stroke: "#FFC000",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1826,
    y1: 8.36697,
    x2: 85.4262,
    y2: 8.36697,
    stroke: "#FFFF00",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4263,
    y1: 6.89951,
    x2: 86.9244,
    y2: 6.89951,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4263,
    y1: 12.7693,
    x2: 86.9244,
    y2: 12.7693,
    stroke: "#0070C0",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 80.9316,
    y1: 14.2368,
    x2: 82.4298,
    y2: 14.2368,
    stroke: "#F05790",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 14.2368,
    x2: 80.1823,
    y2: 14.2368,
    stroke: "#00B0F0",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 12.7693,
    x2: 80.1823,
    y2: 12.7693,
    stroke: "#FF0000",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 11.3019,
    x2: 86.924,
    y2: 11.3019,
    stroke: "#0070C0",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 8.36697,
    x2: 79.4332,
    y2: 8.36697,
    stroke: "#639451",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 86.1753,
    y1: 8.36697,
    x2: 86.9244,
    y2: 8.36697,
    stroke: "black",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1826,
    y1: 9.83443,
    x2: 80.9317,
    y2: 9.83443,
    stroke: "#C00000",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 4.49287,
    x2: 81.7491,
    y2: 4.49287,
    stroke: "#C00000",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 80.9316,
    y1: 12.7693,
    x2: 81.6807,
    y2: 12.7693,
    stroke: "#002060",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 82.4297,
    y1: 12.7693,
    x2: 83.1788,
    y2: 12.7693,
    stroke: "#639451",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 83.9277,
    y1: 12.7693,
    x2: 84.6768,
    y2: 12.7693,
    stroke: "#002060",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 86.1753,
    y1: 14.2368,
    x2: 86.9244,
    y2: 14.2368,
    stroke: "#FFFF00",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 84.6768,
    y1: 14.2368,
    x2: 85.4258,
    y2: 14.2368,
    stroke: "#F56E44",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 83.1787,
    y1: 14.2368,
    x2: 83.9278,
    y2: 14.2368,
    stroke: "#F36A0E",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 9.83443,
    x2: 79.4332,
    y2: 9.83443,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 4.49411L87.0248 4.49411",
    stroke: "#639451",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4263,
    y1: 2.19284,
    x2: 92.168,
    y2: 2.19284,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 15.7042,
    x2: 83.9277,
    y2: 15.7042,
    stroke: "#92D050",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 81.6807,
    y1: 18.6392,
    x2: 86.9243,
    y2: 18.6392,
    stroke: "#FFC000",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1826,
    y1: 17.1717,
    x2: 85.4262,
    y2: 17.1717,
    stroke: "#002060",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4263,
    y1: 15.7042,
    x2: 86.9244,
    y2: 15.7042,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 20.1066,
    x2: 86.924,
    y2: 20.1066,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 17.1717,
    x2: 79.4332,
    y2: 17.1717,
    stroke: "#639451",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 86.1753,
    y1: 17.1717,
    x2: 86.9244,
    y2: 17.1717,
    stroke: "black",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1826,
    y1: 18.6392,
    x2: 80.9317,
    y2: 18.6392,
    stroke: "#C00000",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 18.6392,
    x2: 79.4332,
    y2: 18.6392,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 33.3137,
    x2: 83.9277,
    y2: 33.3137,
    stroke: "#92D050",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 81.6807,
    y1: 36.2486,
    x2: 86.9243,
    y2: 36.2486,
    stroke: "#B3E1C1",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1826,
    y1: 34.7812,
    x2: 85.4262,
    y2: 34.7812,
    stroke: "#FFFF00",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4263,
    y1: 33.3137,
    x2: 86.9244,
    y2: 33.3137,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4263,
    y1: 39.1835,
    x2: 86.9244,
    y2: 39.1835,
    stroke: "#0070C0",
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 80.9316,
    y1: 40.651,
    x2: 82.4298,
    y2: 40.651,
    stroke: "#F05790",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 40.651,
    x2: 80.1823,
    y2: 40.651,
    stroke: "#00B0F0",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 39.1835,
    x2: 80.1823,
    y2: 39.1835,
    stroke: "#FF0000",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 37.7161,
    x2: 86.924,
    y2: 37.7161,
    stroke: "#FF0000",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 34.7812,
    x2: 79.4332,
    y2: 34.7812,
    stroke: "#639451",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 86.1753,
    y1: 34.7812,
    x2: 86.9244,
    y2: 34.7812,
    stroke: "black",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1826,
    y1: 36.2486,
    x2: 80.9317,
    y2: 36.2486,
    stroke: "#C00000",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 80.9316,
    y1: 39.1835,
    x2: 81.6807,
    y2: 39.1835,
    stroke: "#002060",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 82.4297,
    y1: 39.1835,
    x2: 83.1788,
    y2: 39.1835,
    stroke: "#639451",
    strokeWidth: 0.5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 83.9277,
    y1: 39.1835,
    x2: 84.6768,
    y2: 39.1835,
    stroke: "#002060",
    strokeWidth: 0.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 86.1753,
    y1: 40.651,
    x2: 86.9244,
    y2: 40.651,
    stroke: "#FFFF00",
    strokeWidth: 0.5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 84.6768,
    y1: 40.651,
    x2: 85.4258,
    y2: 40.651,
    stroke: "#F56E44",
    strokeWidth: 0.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 83.1787,
    y1: 40.651,
    x2: 83.9278,
    y2: 40.651,
    stroke: "#F36A0E",
    strokeWidth: 0.5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 36.2486,
    x2: 79.4332,
    y2: 36.2486,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 42.1185,
    x2: 83.9277,
    y2: 42.1185,
    stroke: "#92D050",
    strokeWidth: 0.5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 81.6807,
    y1: 45.0534,
    x2: 86.9243,
    y2: 45.0534,
    stroke: "#FFC000",
    strokeWidth: 0.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1826,
    y1: 43.5859,
    x2: 85.4262,
    y2: 43.5859,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4263,
    y1: 42.1185,
    x2: 86.9244,
    y2: 42.1185,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4263,
    y1: 47.9883,
    x2: 86.9244,
    y2: 47.9883,
    stroke: "#0070C0",
    strokeWidth: 0.5
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 80.9316,
    y1: 49.4557,
    x2: 82.4298,
    y2: 49.4557,
    stroke: "#F05790",
    strokeWidth: 0.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6001,
    y1: 4.49287,
    x2: 80.0983,
    y2: 4.49287,
    stroke: "#F05790",
    strokeWidth: 0.5
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 79,
    y1: 5.59287,
    x2: 87,
    y2: 5.59287,
    stroke: "#F05790",
    strokeWidth: 0.5
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 49.4557,
    x2: 80.1823,
    y2: 49.4557,
    stroke: "#00B0F0",
    strokeWidth: 0.5
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 47.9883,
    x2: 80.1823,
    y2: 47.9883,
    stroke: "#FF0000",
    strokeWidth: 0.5
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 46.5208,
    x2: 86.924,
    y2: 46.5208,
    stroke: "#00B0F0",
    strokeWidth: 0.5
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 43.5859,
    x2: 79.4332,
    y2: 43.5859,
    stroke: "#639451",
    strokeWidth: 0.5
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 86.1753,
    y1: 43.5859,
    x2: 86.9244,
    y2: 43.5859,
    stroke: "black",
    strokeWidth: 0.5
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1826,
    y1: 45.0534,
    x2: 80.9317,
    y2: 45.0534,
    stroke: "#C00000",
    strokeWidth: 0.5
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 80.9316,
    y1: 47.9883,
    x2: 81.6807,
    y2: 47.9883,
    stroke: "#002060",
    strokeWidth: 0.5
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 82.4297,
    y1: 47.9883,
    x2: 83.1788,
    y2: 47.9883,
    stroke: "#639451",
    strokeWidth: 0.5
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 83.9277,
    y1: 47.9883,
    x2: 84.6768,
    y2: 47.9883,
    stroke: "#002060",
    strokeWidth: 0.5
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 86.1753,
    y1: 49.4557,
    x2: 86.9244,
    y2: 49.4557,
    stroke: "#FFFF00",
    strokeWidth: 0.5
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 84.6768,
    y1: 49.4557,
    x2: 85.4258,
    y2: 49.4557,
    stroke: "#F56E44",
    strokeWidth: 0.5
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 83.1787,
    y1: 49.4557,
    x2: 83.9278,
    y2: 49.4557,
    stroke: "#F36A0E",
    strokeWidth: 0.5
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 45.0534,
    x2: 79.4332,
    y2: 45.0534,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 50.9232,
    x2: 83.9277,
    y2: 50.9232,
    stroke: "#92D050",
    strokeWidth: 0.5
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    x1: 81.6807,
    y1: 54.5918,
    x2: 92.1679,
    y2: 54.5918,
    stroke: "#FF0000",
    strokeWidth: 0.5
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    x1: 80.9316,
    y1: 53.4912,
    x2: 86.1752,
    y2: 53.4912,
    stroke: "#FFC000",
    strokeWidth: 0.5
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    x1: 73.4409,
    y1: 54.5918,
    x2: 79.4336,
    y2: 54.5918,
    stroke: "#FFC000",
    strokeWidth: 0.5
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1826,
    y1: 52.3906,
    x2: 85.4262,
    y2: 52.3906,
    stroke: "#FFFF00",
    strokeWidth: 0.5
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    x1: 85.4263,
    y1: 50.9232,
    x2: 86.9244,
    y2: 50.9232,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    x1: 89.1714,
    y1: 53.4912,
    x2: 90.6696,
    y2: 53.4912,
    stroke: "#0070C0",
    strokeWidth: 0.5
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    x1: 77.186,
    y1: 53.4912,
    x2: 78.6842,
    y2: 53.4912,
    stroke: "#F05790",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1753 52.2738H87.6735",
    stroke: "#00B0F0",
    strokeWidth: 0.5
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    x1: 74.939,
    y1: 53.4912,
    x2: 76.4371,
    y2: 53.4912,
    stroke: "#FF0000",
    strokeWidth: 0.5
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    x1: 78.6841,
    y1: 52.3906,
    x2: 79.4332,
    y2: 52.3906,
    stroke: "#639451",
    strokeWidth: 0.5
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1826,
    y1: 54.5918,
    x2: 80.9317,
    y2: 54.5918,
    stroke: "#C00000",
    strokeWidth: 0.5
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    x1: 77.9351,
    y1: 52.3906,
    x2: 78.6841,
    y2: 52.3906,
    stroke: "#002060",
    strokeWidth: 0.5
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    x1: 73.4409,
    y1: 53.4912,
    x2: 74.19,
    y2: 53.4912,
    stroke: "#002060",
    strokeWidth: 0.5
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    x1: 91.4189,
    y1: 53.4912,
    x2: 92.168,
    y2: 53.4912,
    stroke: "#FFFF00",
    strokeWidth: 0.5
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    x1: 86.9243,
    y1: 53.4912,
    x2: 88.4225,
    y2: 53.4912,
    stroke: "#F56E44",
    strokeWidth: 0.5
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    x1: 79.4336,
    y1: 53.4912,
    x2: 80.1827,
    y2: 53.4912,
    stroke: "#A77CDE",
    strokeWidth: 0.5
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 11.2363,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 120.542 53.866)",
    stroke: "#00B0F0",
    strokeWidth: 0.4
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 11.2363,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 116.028 52.4548)",
    stroke: "#5D1593",
    strokeWidth: 0.4
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.511 51.0061)",
    stroke: "#92D050",
    strokeWidth: 0.4
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 115.243 4.2429)",
    stroke: "#92D050",
    strokeWidth: 0.4
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 111.477 48.1089)",
    stroke: "#FFC000",
    strokeWidth: 0.4
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.994 49.5575)",
    stroke: "#FFFF00",
    strokeWidth: 0.4
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.77 51.0904)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    x1: 109.001,
    y1: 4.4429,
    x2: 105.001,
    y2: 4.46162,
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.693 45.221)",
    stroke: "#0070C0",
    strokeWidth: 0.4
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.168 43.6976)",
    stroke: "#F05790",
    strokeWidth: 0.4
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.416 43.6695)",
    stroke: "#00B0F0",
    strokeWidth: 0.4
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.435 45.1368)",
    stroke: "#FF0000",
    strokeWidth: 0.4
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 8.23995,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.454 46.6041)",
    stroke: "#0070C0",
    strokeWidth: 0.4
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.492 49.5388)",
    stroke: "#639451",
    strokeWidth: 0.4
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.002 49.6324)",
    stroke: "black",
    strokeWidth: 0.4
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.975 48.0902)",
    stroke: "#C00000",
    strokeWidth: 0.4
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.188 45.1649)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 110.69 45.1836)",
    stroke: "#639451",
    strokeWidth: 0.4
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 109.191 45.2023)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 106.925 43.7631)",
    stroke: "#FFFF00",
    strokeWidth: 0.4
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 108.423 43.7444)",
    stroke: "#F56E44",
    strokeWidth: 0.4
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 109.922 43.7256)",
    stroke: "#F36A0E",
    strokeWidth: 0.4
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.473 48.0715)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 6.74178,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.808 54.0251)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.396 42.2021)",
    stroke: "#92D050",
    strokeWidth: 0.4
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 111.362 39.3049)",
    stroke: "#FFC000",
    strokeWidth: 0.4
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.879 40.7535)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.655 42.2864)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.579 36.417)",
    stroke: "#0070C0",
    strokeWidth: 0.4
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.054 34.8935)",
    stroke: "#F05790",
    strokeWidth: 0.4
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.301 34.8655)",
    stroke: "#00B0F0",
    strokeWidth: 0.4
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.32 36.3328)",
    stroke: "#FF0000",
    strokeWidth: 0.4
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 8.23995,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.339 37.8001)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.377 40.7348)",
    stroke: "#639451",
    strokeWidth: 0.4
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 106.887 40.8284)",
    stroke: "black",
    strokeWidth: 0.4
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.86 39.2862)",
    stroke: "#C00000",
    strokeWidth: 0.4
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.073 36.3609)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 110.575 36.3796)",
    stroke: "#639451",
    strokeWidth: 0.4
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 109.077 36.3983)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 106.811 34.9591)",
    stroke: "#FFFF00",
    strokeWidth: 0.4
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 108.309 34.9403)",
    stroke: "#F56E44",
    strokeWidth: 0.4
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 109.807 34.9216)",
    stroke: "#F36A0E",
    strokeWidth: 0.4
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.358 39.2675)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.282 33.3981)",
    stroke: "#F56E44",
    strokeWidth: 0.4
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.541 33.4824)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 111.133 32.6969)",
    stroke: "#B3E1C1",
    strokeWidth: 0.4
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.35 18.809)",
    stroke: "#0070C0",
    strokeWidth: 0.4
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 111.824 17.2855)",
    stroke: "#F05790",
    strokeWidth: 0.4
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.072 17.2574)",
    stroke: "#00B0F0",
    strokeWidth: 0.4
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.091 18.7247)",
    stroke: "#FF0000",
    strokeWidth: 0.4
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 8.23995,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.11 20.1921)",
    stroke: "#FF0000",
    strokeWidth: 0.4
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.631 32.6781)",
    stroke: "#C00000",
    strokeWidth: 0.4
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 111.844 18.7528)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 110.346 18.7715)",
    stroke: "#639451",
    strokeWidth: 0.4
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 108.848 18.7903)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 106.582 17.351)",
    stroke: "#FFFF00",
    strokeWidth: 0.4
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 108.079 17.3323)",
    stroke: "#F56E44",
    strokeWidth: 0.4
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 109.578 17.3136)",
    stroke: "#F36A0E",
    strokeWidth: 0.4
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.129 32.6594)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.053 15.7901)",
    stroke: "#92D050",
    strokeWidth: 0.4
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 111.018 12.8929)",
    stroke: "#FFC000",
    strokeWidth: 0.4
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.536 14.3415)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.311 15.8743)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.235 10.005)",
    stroke: "#0070C0",
    strokeWidth: 0.4
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 111.71 8.48148)",
    stroke: "#F05790",
    strokeWidth: 0.4
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 113.957 8.45341)",
    stroke: "#00B0F0",
    strokeWidth: 0.4
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 113.976 9.92073)",
    stroke: "#FF0000",
    strokeWidth: 0.4
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 8.23995,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 113.995 11.3881)",
    stroke: "#00B0F0",
    strokeWidth: 0.4
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.033 14.3227)",
    stroke: "#639451",
    strokeWidth: 0.4
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 106.543 14.4163)",
    stroke: "black",
    strokeWidth: 0.4
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.517 12.8741)",
    stroke: "#C00000",
    strokeWidth: 0.4
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 111.729 9.94881)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 110.231 9.96753)",
    stroke: "#639451",
    strokeWidth: 0.4
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 108.733 9.98625)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 106.467 8.547)",
    stroke: "#FFFF00",
    strokeWidth: 0.4
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.965 8.52829)",
    stroke: "#F56E44",
    strokeWidth: 0.4
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 109.462 8.50957)",
    stroke: "#F36A0E",
    strokeWidth: 0.4
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.014 12.8554)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 113.938 6.98605)",
    stroke: "#92D050",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.002 2.04289L99.5156 2.17394",
    stroke: "#FF0000",
    strokeWidth: 0.4
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.2436,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 111.657 3.14291)",
    stroke: "#FFC000",
    strokeWidth: 0.4
  })), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 5.99269,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 119.133 1.7429)",
    stroke: "#FFC000",
    strokeWidth: 0.4
  })), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 5.9429,
    x2: 107,
    y2: 5.9429,
    stroke: "#FFFF00",
    strokeWidth: 0.4
  })), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 107.197 7.07033)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 103.418 3.14291)",
    stroke: "#0070C0",
    strokeWidth: 0.4
  })), _line173 || (_line173 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 115.402 3.14291)",
    stroke: "#F05790",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.498 5.9429L105 5.96162",
    stroke: "#00B0F0",
    strokeWidth: 0.4
  })), _line174 || (_line174 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 117.649 3.14291)",
    stroke: "#FF0000",
    strokeWidth: 0.4
  })), _line175 || (_line175 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 113.919 5.7429)",
    stroke: "#639451",
    strokeWidth: 0.4
  })), _line176 || (_line176 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 112.392 1.8429)",
    stroke: "#C00000",
    strokeWidth: 0.4
  })), _line177 || (_line177 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 114.668 5.7429)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line178 || (_line178 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 119.147 3.14291)",
    stroke: "#002060",
    strokeWidth: 0.4
  })), _line179 || (_line179 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 101.171 3.14291)",
    stroke: "#FFFF00",
    strokeWidth: 0.4
  })), _line180 || (_line180 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 1.49817,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 105.665 3.14291)",
    stroke: "#F56E44",
    strokeWidth: 0.4
  })), _line181 || (_line181 = /*#__PURE__*/React.createElement("line", {
    y1: -0.2,
    x2: 0.749086,
    y2: -0.2,
    transform: "matrix(-0.999922 0.012496 -0.0130245 -0.999915 113.155 3.14291)",
    stroke: "#A77CDE",
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0068 31.2265V30.9115C26.4668 30.9115 26.7568 30.8515 26.8768 30.7315L26.0368 28.4365H23.1568L22.3768 30.6415C22.4768 30.8215 22.7868 30.9115 23.3068 30.9115V31.2265H20.8468V30.9115C21.4068 30.9115 21.7218 30.8065 21.7918 30.5965L24.7018 22.4515H25.4218L28.3318 30.5965C28.4018 30.8065 28.7218 30.9115 29.2918 30.9115V31.2265H26.0068ZM24.5818 24.4465L23.3368 27.9415H25.8568L24.5818 24.4465ZM31.5871 22.4515V22.7665C31.1271 22.7665 30.8371 22.8265 30.7171 22.9465L33.0121 29.2315L35.2171 23.0365C35.1171 22.8565 34.8071 22.7665 34.2871 22.7665V22.4515H36.7471V22.7665C36.1871 22.7665 35.8821 22.8465 35.8321 23.0065L32.8921 31.2265H32.1721L29.2621 23.0815C29.1821 22.8715 28.8621 22.7665 28.3021 22.7665V22.4515H31.5871ZM37.2413 31.2265V30.9115C37.7813 30.9115 38.0963 30.8115 38.1863 30.6115V23.0665C38.0963 22.8665 37.7813 22.7665 37.2413 22.7665V22.4515H43.2863V23.9065H42.9713C42.9713 23.3665 42.8713 23.0515 42.6713 22.9615H39.5663V26.4115H41.6663C41.8663 26.3215 41.9663 26.0065 41.9663 25.4665H42.2813V27.8665H41.9663C41.9663 27.3265 41.8663 27.0115 41.6663 26.9215H39.5663V30.7165H42.9863C43.2363 30.6065 43.4613 30.2915 43.6613 29.7715H43.9613L43.6013 31.2265H37.2413ZM44.8439 31.2265V30.9115C45.3839 30.9115 45.6989 30.8115 45.7889 30.6115V23.0665C45.6989 22.8665 45.3839 22.7665 44.8439 22.7665V22.4515H48.2339C49.4739 22.4515 50.4139 22.6765 51.0539 23.1265C51.6939 23.5765 52.0139 24.0915 52.0139 24.6715C52.0139 25.2215 51.8489 25.7065 51.5189 26.1265C51.1889 26.5365 50.6989 26.8365 50.0489 27.0265L52.0439 30.5965C52.1439 30.8065 52.4739 30.9115 53.0339 30.9115V31.2265H52.3889C51.6889 31.2265 51.2339 31.1865 51.0239 31.1065C50.8139 31.0265 50.6039 30.8065 50.3939 30.4465L48.5789 27.2365H47.1689V30.6115C47.2589 30.8115 47.5739 30.9115 48.1139 30.9115V31.2265H44.8439ZM47.1689 22.9615V26.7265H48.4139C49.2139 26.7265 49.7639 26.5715 50.0639 26.2615C50.3639 25.9515 50.5139 25.4265 50.5139 24.6865C50.5139 24.1365 50.3439 23.7115 50.0039 23.4115C49.6739 23.1115 49.0839 22.9615 48.2339 22.9615H47.1689ZM53.5597 31.2265V30.9115C54.0997 30.9115 54.4147 30.8115 54.5047 30.6115V23.0665C54.4147 22.8665 54.0997 22.7665 53.5597 22.7665V22.4515H56.9497C58.1897 22.4515 59.1297 22.6765 59.7697 23.1265C60.4097 23.5765 60.7297 24.0915 60.7297 24.6715C60.7297 25.2215 60.5647 25.7065 60.2347 26.1265C59.9047 26.5365 59.4147 26.8365 58.7647 27.0265L60.7597 30.5965C60.8597 30.8065 61.1897 30.9115 61.7497 30.9115V31.2265H61.1047C60.4047 31.2265 59.9497 31.1865 59.7397 31.1065C59.5297 31.0265 59.3197 30.8065 59.1097 30.4465L57.2947 27.2365H55.8847V30.6115C55.9747 30.8115 56.2897 30.9115 56.8297 30.9115V31.2265H53.5597ZM55.8847 22.9615V26.7265H57.1297C57.9297 26.7265 58.4797 26.5715 58.7797 26.2615C59.0797 25.9515 59.2297 25.4265 59.2297 24.6865C59.2297 24.1365 59.0597 23.7115 58.7197 23.4115C58.3897 23.1115 57.7997 22.9615 56.9497 22.9615H55.8847ZM63.8055 26.7265C63.8055 27.3865 63.8955 28.0215 64.0755 28.6315C64.2655 29.2315 64.5705 29.7565 64.9905 30.2065C65.4205 30.6465 65.9305 30.8665 66.5205 30.8665C67.1105 30.8665 67.6055 30.6565 68.0055 30.2365C68.4155 29.8165 68.7005 29.3265 68.8605 28.7665C69.0305 28.1965 69.1155 27.5965 69.1155 26.9665C69.1155 26.3165 69.0205 25.6865 68.8305 25.0765C68.6405 24.4565 68.3305 23.9265 67.9005 23.4865C67.4805 23.0365 66.9805 22.8115 66.4005 22.8115C65.9505 22.8115 65.5505 22.9315 65.2005 23.1715C64.8605 23.4115 64.5905 23.7315 64.3905 24.1315C64.2005 24.5215 64.0555 24.9365 63.9555 25.3765C63.8555 25.8165 63.8055 26.2665 63.8055 26.7265ZM62.3055 26.8465C62.3055 25.5965 62.6955 24.5265 63.4755 23.6365C64.2555 22.7465 65.2505 22.3015 66.4605 22.3015C67.6705 22.3015 68.6655 22.7465 69.4455 23.6365C70.2255 24.5265 70.6155 25.5965 70.6155 26.8465C70.6155 28.0965 70.2205 29.1665 69.4305 30.0565C68.6505 30.9365 67.6605 31.3765 66.4605 31.3765C65.2405 31.3765 64.2405 30.9365 63.4605 30.0565C62.6905 29.1765 62.3055 28.1065 62.3055 26.8465ZM71.7823 31.2265V30.9115C72.3223 30.9115 72.6373 30.8115 72.7273 30.6115V23.0665C72.6373 22.8665 72.3223 22.7665 71.7823 22.7665V22.4515H77.8273V23.9065H77.5123C77.5123 23.3665 77.4123 23.0515 77.2123 22.9615H74.1073V26.4115H76.2073C76.4073 26.3215 76.5073 26.0065 76.5073 25.4665H76.8223V27.8665H76.5073C76.5073 27.3265 76.4073 27.0115 76.2073 26.9215H74.1073V30.7165H77.5273C77.7773 30.6065 78.0023 30.2915 78.2023 29.7715H78.5023L78.1423 31.2265H71.7823ZM82.4899 31.3765C81.9999 31.3765 81.4999 31.3015 80.9899 31.1515C80.4799 31.0015 80.2149 30.9265 80.1949 30.9265C80.1349 30.9265 80.0649 30.9565 79.9849 31.0165C79.9049 31.0765 79.8649 31.1465 79.8649 31.2265H79.5199V29.1415H79.8499C79.9599 29.7415 80.2549 30.1815 80.7349 30.4615C81.2249 30.7315 81.7799 30.8665 82.3999 30.8665C82.9299 30.8665 83.3649 30.7465 83.7049 30.5065C84.0449 30.2665 84.2149 29.9065 84.2149 29.4265C84.2149 29.2065 84.1649 29.0065 84.0649 28.8265C83.9749 28.6465 83.8299 28.4815 83.6299 28.3315C83.4399 28.1715 83.2549 28.0415 83.0749 27.9415C82.8949 27.8315 82.6599 27.7015 82.3699 27.5515C82.0899 27.3915 81.8749 27.2665 81.7249 27.1765C81.3749 26.9565 81.1149 26.7915 80.9449 26.6815C80.7749 26.5615 80.5549 26.3865 80.2849 26.1565C80.0249 25.9265 79.8349 25.6865 79.7149 25.4365C79.5949 25.1865 79.5349 24.9165 79.5349 24.6265C79.5349 24.0365 79.8049 23.5015 80.3449 23.0215C80.8849 22.5415 81.4899 22.3015 82.1599 22.3015C82.4499 22.3015 82.8099 22.3765 83.2399 22.5265C83.6699 22.6765 83.9149 22.7515 83.9749 22.7515C84.0949 22.7515 84.1549 22.6515 84.1549 22.4515H84.4999L84.6499 24.3565H84.3199C84.2599 23.9165 84.0399 23.5515 83.6599 23.2615C83.2799 22.9615 82.7849 22.8115 82.1749 22.8115C81.7149 22.8115 81.3449 22.9615 81.0649 23.2615C80.7949 23.5515 80.6599 23.8465 80.6599 24.1465C80.6599 24.3365 80.7049 24.5165 80.7949 24.6865C80.8849 24.8465 81.0249 24.9965 81.2149 25.1365C81.4049 25.2765 81.5849 25.4015 81.7549 25.5115C81.9249 25.6115 82.1499 25.7365 82.4299 25.8865C82.7199 26.0365 82.9399 26.1565 83.0899 26.2465C83.4999 26.4965 83.7949 26.6815 83.9749 26.8015C84.1549 26.9215 84.3849 27.1065 84.6649 27.3565C84.9549 27.6065 85.1549 27.8665 85.2649 28.1365C85.3849 28.3965 85.4449 28.6865 85.4449 29.0065C85.4449 29.7465 85.1449 30.3265 84.5449 30.7465C83.9449 31.1665 83.2599 31.3765 82.4899 31.3765ZM94.7115 22.8115C93.8515 22.8115 93.1365 23.1665 92.5665 23.8765C91.9965 24.5865 91.7115 25.5065 91.7115 26.6365C91.7115 27.9565 92.0115 28.9915 92.6115 29.7415C93.2115 30.4915 93.9315 30.8665 94.7715 30.8665C95.2715 30.8665 95.7665 30.6965 96.2565 30.3565C96.7465 30.0065 97.0615 29.6365 97.2015 29.2465L97.5615 29.4265C97.3315 29.9765 96.9665 30.4415 96.4665 30.8215C95.9765 31.1915 95.3115 31.3765 94.4715 31.3765C93.1415 31.3765 92.0865 30.9465 91.3065 30.0865C90.5365 29.2165 90.1515 28.1765 90.1515 26.9665C90.1515 25.5665 90.5965 24.4415 91.4865 23.5915C92.3865 22.7315 93.4565 22.3015 94.6965 22.3015C94.9865 22.3015 95.3215 22.3765 95.7015 22.5265C96.0815 22.6765 96.3015 22.7515 96.3615 22.7515C96.4815 22.7515 96.5415 22.6515 96.5415 22.4515H96.8865L97.0365 24.3565H96.7065C96.6365 23.9065 96.4365 23.5365 96.1065 23.2465C95.7865 22.9565 95.3215 22.8115 94.7115 22.8115ZM100.031 26.7265C100.031 27.3865 100.121 28.0215 100.301 28.6315C100.491 29.2315 100.796 29.7565 101.216 30.2065C101.646 30.6465 102.156 30.8665 102.746 30.8665C103.336 30.8665 103.831 30.6565 104.231 30.2365C104.641 29.8165 104.926 29.3265 105.086 28.7665C105.256 28.1965 105.341 27.5965 105.341 26.9665C105.341 26.3165 105.246 25.6865 105.056 25.0765C104.866 24.4565 104.556 23.9265 104.126 23.4865C103.706 23.0365 103.206 22.8115 102.626 22.8115C102.176 22.8115 101.776 22.9315 101.426 23.1715C101.086 23.4115 100.816 23.7315 100.616 24.1315C100.426 24.5215 100.281 24.9365 100.181 25.3765C100.081 25.8165 100.031 26.2665 100.031 26.7265ZM98.5311 26.8465C98.5311 25.5965 98.9211 24.5265 99.7011 23.6365C100.481 22.7465 101.476 22.3015 102.686 22.3015C103.896 22.3015 104.891 22.7465 105.671 23.6365C106.451 24.5265 106.841 25.5965 106.841 26.8465C106.841 28.0965 106.446 29.1665 105.656 30.0565C104.876 30.9365 103.886 31.3765 102.686 31.3765C101.466 31.3765 100.466 30.9365 99.6861 30.0565C98.9161 29.1765 98.5311 28.1065 98.5311 26.8465ZM108.008 31.2265V30.9115C108.548 30.9115 108.863 30.8115 108.953 30.6115V23.0665C108.863 22.8665 108.548 22.7665 108.008 22.7665V22.4515H111.458C112.788 22.4515 113.858 22.8565 114.668 23.6665C115.478 24.4665 115.883 25.5165 115.883 26.8165C115.883 28.1165 115.488 29.1765 114.698 29.9965C113.908 30.8165 112.888 31.2265 111.638 31.2265H108.008ZM110.333 22.8865V30.7165H111.638C111.958 30.7165 112.268 30.6465 112.568 30.5065C112.878 30.3565 113.173 30.1365 113.453 29.8465C113.733 29.5565 113.958 29.1515 114.128 28.6315C114.298 28.1115 114.383 27.5115 114.383 26.8315C114.383 25.5315 114.088 24.5515 113.498 23.8915C112.918 23.2215 112.238 22.8865 111.458 22.8865H110.333ZM117.061 31.2265V30.9115C117.601 30.9115 117.916 30.8115 118.006 30.6115V23.0665C117.916 22.8665 117.601 22.7665 117.061 22.7665V22.4515H123.106V23.9065H122.791C122.791 23.3665 122.691 23.0515 122.491 22.9615H119.386V26.4115H121.486C121.686 26.3215 121.786 26.0065 121.786 25.4665H122.101V27.8665H121.786C121.786 27.3265 121.686 27.0115 121.486 26.9215H119.386V30.7165H122.806C123.056 30.6065 123.281 30.2915 123.481 29.7715H123.781L123.421 31.2265H117.061Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0555 3.64811L69.4949 3.74707C66.2615 3.96221 64.4599 4.25732 63.5 5.24288L64.0555 3.64811Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 50.2429C66.907 51.7958 68.3012 52.6698 71.5 52.7429H62.2012L65.5 50.2429Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51.2429V52.7429H52C55.304 52.5245 56.6464 52.2126 58 51.2429Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 3.74288L31 6.24288C30.1023 4.90719 28.7555 3.98197 25 3.74288H34.5Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45 3.74288C42.1329 3.96137 40.6475 4.14544 39.5 5.24288L38.5 3.74288H45Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 1.84289,
    width: 20,
    height: 2,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6001,
    y: 1.84289,
    width: 15,
    height: 2,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.6001,
    y: 54.7429,
    width: 20,
    height: 2,
    transform: "rotate(-180 71.6001 54.7429)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 54.7429,
    width: 15,
    height: 2,
    transform: "rotate(-180 40 54.7429)",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6987 5.85559L37.6269 1.85559L48.8121 21.2289L39.5 21.2429L30.6987 5.85559Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8329 50.6298L58.9047 54.6298L45.9245 32.2429L55.4999 32.2429L65.8329 50.6298Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2754 2.20468L64.6727 3.71044L54 21.2429L50.0001 21.2429L62.2754 2.20468Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2754 2.20468L64.6727 3.71044L54 21.2429L50.0001 21.2429L62.2754 2.20468Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0326 54.1096L29.676 52.541L42.8417 32.2429L47 32.2428L32.0326 54.1096Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0326 54.1096L29.676 52.541L42.8417 32.2429L47 32.2428L32.0326 54.1096Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3624 5.54765C59.5466 4.08139 56.8596 3.23174 55.2049 3.25044C53.5502 3.26913 62.4843 2.71362 62.4843 2.71362L60.3624 5.54765Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6879 50.8657C34.4887 52.2976 37.688 52.8657 39.5 52.7429C41.312 52.6201 34.1242 54.522 34.1242 54.522L33.6879 50.8657Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 51.2429,
    width: 1,
    height: 2,
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5885 51.4344C32.6767 50.626 30.4064 53.1569 30.4064 53.1569C30.4064 53.1569 22.5001 52.743 25.0001 52.7429C27.5 52.7429 28.5003 52.2429 30.5885 51.4344Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogov2);
export default __webpack_public_path__ + "static/media/logov2.0b3b5836b358b8d27596fde448770dd9.svg";
export { ForwardRef as ReactComponent };